
















































import { ResearchField } from "@gaia-project/engine";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import BoardAction from "./BoardAction.vue";
import ResearchTrack from "./ResearchTrack.vue";
import TechTile from "./TechTile.vue";

@Component({
  computed: {
    fields(): ResearchField[] {
      return ResearchField.values(this.expansions);
    },
    expansions() {
      return this.$store.state.data.expansions;
    },
    viewWidth() {
      return this.fields.length * 60;
    },
  },
  components: {
    ResearchTrack,
    TechTile,
    BoardAction,
  },
})
export default class ResearchBoard extends Vue {}
